export enum ButtonLabel {
    DUPLICATE = 'mimic.page.button.duplicate',
    MOVE = 'mimic.option-dialog.move-mimic',
}

export enum DuplicateItemType {
    FOLDER = 'folder',
    MIMIC = 'mimic',
    LIBRARY = 'library',
    COMPONENT = 'component',
    CATEGORY = 'category',
    LAYER = 'layer',
}
